/* eslint-disable no-unused-vars */
import React, { useCallback, useState } from 'react';

import {
  Flex,
  Text,
  HStack,
  Wrap,
  WrapItem,
  Image,
} from '@chakra-ui/react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useBoolean, useToggle } from 'react-use';

import { Button, Icon, Input } from 'components';
import ZoomImage from 'containers/Modals/ZoomImage';

import { IMAGE_PLACEHOLDER } from './constants';

export default function Images({
  index, allowEdition, execution, forceParentRerender,
}) {
  const [image, setImage] = useState<string>();

  const { register, control, watch } = useFormContext();
  const [, forceRerender] = useBoolean(false);
  const fields = watch(`fields.${index}.inputs`);
  const { append, remove } = useFieldArray({
    control,
    name: `fields.${index}.inputs`,
  });

  const Item = useCallback(({ label, idx, imageUrl = IMAGE_PLACEHOLDER }) => {
    const [isEditing, toggle] = useToggle(false);

    return (
      <WrapItem
        p={4}
        borderRadius={8}
        alignItems="center"
        bg="white.default"
        height={100}
        width="32%"
        justifyContent="space-between">
        <HStack spacing={4}>
          <Image
            cursor="pointer"
            onClick={() => setImage(imageUrl)}
            height={20}
            src={imageUrl}
          />
          <Text
            hidden={isEditing}
            variant="mediumSemiBold">
            {label}
          </Text>
          <Input
            viewProps={{
              hidden: !isEditing,
              alignSelf: 'center',
            }}
            defaultValue={label}
            {...register(`fields.${index}.inputs.${idx}.label`)}
          />
          {allowEdition && (
            <Icon
              name={isEditing ? 'check' : 'edit'}
              onClick={() => {
                toggle();
                forceRerender();
                forceParentRerender();
              }}
              mx={4}
            />
          )}
        </HStack>
        <Icon
          hidden={!allowEdition}
          cursor="pointer"
          onClick={() => remove(idx)}
          position="relative"
          top={-50}
          right={-6}
          size="lg"
          name="times-circle"
        />
      </WrapItem>
    );
  }, [remove, register, index, allowEdition, forceRerender]);

  return (
    <Flex flexDir="column">
      <ZoomImage
        isOpen={!!image}
        onClose={() => setImage(undefined)}
        data={image}
      />
      <Wrap>
        {(execution?.fields ?? fields)?.map((item, idx) => (
          <Item
            key={`fields.${index}.inputs.${idx}.label`}
            {...item}
            idx={idx}
          />
        ))}
      </Wrap>
      <Button
        hidden={!allowEdition}
        alignSelf="flex-start"
        variant="ghost.blue"
        onClick={() => {
          append({ active: true, label: 'Novo Item' });
        }}>
        <Icon name="plus" />
        <Text
          variant="mediumBold"
          ml={2}>
          Adicionar Item
        </Text>
      </Button>
    </Flex>
  );
}
